import SearchIcon from "@mui/icons-material/Search";
import { Typography } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import StarShrinkIco from "../../../assets/icons/StarShrinkIco";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import { AssistCountCall } from "../../../redux/action/AIAssist";
import { SearchAndListOfResumes } from "../../../redux/action/Candidate";
import {
  CandidateChatBot,
  CandidateChatBotGetCall,
} from "../../../redux/action/ChatBot";
import { getColor, HandleSkeletion } from "../../../utils/constants";
import FullSizeChatBot from "../../chat-bot/FullSizeChatBot";
import { CustomDiv } from "../../chat-bot/style";
import {
  CommonGrid2,
  DataFound,
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import { CommonTippy, CustomizeSpan } from "../../jobs/style";

export default function RecruitingAgent() {
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [chatBotData, setChatBotData] = useState({
    message: [],
    value: "",
    loader: false,
    pageLoader: false,
    details: "See Details",
  });
  const [jobData, setJobData] = useState({
    data: [],
    loading: false,
    search: "",
    value: "",
    offset: 0,
    hasMore: true,
    loadMoreLoading: false,
  });
  useEffect(() => {
    const el = listRef.current;
    if (!el) return;

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = el;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;
      if (
        isAtBottom &&
        jobData.hasMore &&
        !jobData.loading &&
        !jobData.loadMoreLoading
      ) {
        setJobData((prev) => ({ ...prev, offset: prev.offset + 40 }));
      }
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [jobData.hasMore, jobData.loading, jobData.loadMoreLoading]);
  const listRef = useRef(null);
  const dispatch = useDispatch();
  const gridRef = useRef();
  const timeoutRef = useRef(null);
  const [isBottomVisible, setIsBottomVisible] = useState(true);

  const handleActivityChange = () => {
    setChatBotData((prev) => ({
      ...prev,
      details: prev.details === "See Details" ? "Hide Details" : "See Details",
    }));
  };
  const fetchJobsList = async ({ q = "", status_flag = false, offset = 0 }) => {
    try {
      setJobData((prev) => ({
        ...prev,
        loading: prev.offset === 0,
        loadMoreLoading: prev.offset !== 0,
      }));
      const filters = [
        {
          field: "personal_details.location.keyword",
          value: [],
        },
        {
          field: "personal_details.industry.keyword",
          value: [],
        },
        {
          field: "personal_details.seniority_level.keyword",
          value: [],
        },
        {
          field: "updated_at",
          value: [],
        },
        {
          field: "elc_table.qualifications.name.keyword",
          value: [],
        },
      ].filter((filter) => Object.values(filter).some((value) => value !== ""));

      let params = {
        limit: 40,
        offset: offset,
      };
      let payload = {
        q: q,
        filter: filters,
        sort: {
          status: false,
        },

        status_flag: status_flag,
        organization_id: localStorageData?.organization_id,
        pagination: true,
        ai_assist:true,
      };

      const response = await SearchAndListOfResumes(payload, params);
      await AssistCountCall(localStorageData?.organization_id);
      if (
        q === "" &&
        response?.data?.results?.length !== 0 &&
        jobData.value === ""
      ) {
        handleChatBotFetchData({ id: response?.data?.results[0] });
      }
      setJobData((prev) => ({
        ...prev,
        data:
          prev.offset === 0
            ? response?.data?.results || []
            : [...prev.data, ...(response?.data?.results || [])],
        loading: false,
        loadMoreLoading: false,
        hasMore: (response?.data?.current_page) !== response?.data?.total_pages,
        ...(q === "" &&
        response?.data?.results?.length !== 0 &&
        prev.value === ""
          ? { value: response?.data?.results[0] }
          : {}),
      }));
    } catch (error) {
      setJobData((prev) => ({
        ...prev,
        loading: false,
        loadMoreLoading: false,
      }));
    }
  };

  useEffect(() => {
    fetchJobsList({ q: "", offset: 0 });
  }, []);
  useEffect(() => {
    if (jobData.offset !== 0) {
      fetchJobsList({ q: jobData.search, offset: jobData.offset });
    }
  }, [jobData.offset]);
  const handleSearchInput = (e) => {
    const newValue = e.target.value;
    setJobData((prev) => ({ ...prev, search: newValue, offset: 0 }));
    handleDelay(newValue, 500);
  };

  const handleDelay = (value, delay) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      fetchJobsList({ q: value, offset: 0 });
    }, delay);
  };

  const handleButtonClick = (value) => {
    setJobData((prev) => ({
      ...prev,
      value: value,
    }));

    setChatBotData((prev) => ({
      ...prev,
      message: [],
    }));
    handleChatBotFetchData({ id: value });
  };

  const handleChatBotFetchData = async ({ id = jobData.value }) => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await CandidateChatBotGetCall(id?.resume_id);
      const messages = [];
      data?.data.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, ...messages],
        bubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(true);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;
    let payload = {
      query: chatBotData.value,
      filter_criteria: {
        type: "resume_data",
        resume_data_id: jobData.value?.resume_id,
      },
    };

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      const data = await dispatch(CandidateChatBot(payload));
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const memoizedSidebar = useMemo(() => {
    return (
      <CommonGrid2
        width={"300px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        top={"0px"}
        position={"sticky"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        background="#F6F8FB"
        scrollBar="5px"
        ref={gridRef}
      >
        <CommonGrid2
          item
          padding={"1rem"}
          overflowY={"scroll"}
          scrollStyle
          displayBar="none"
        >
          <CommonTextField
            placeholder="Search Candidates..."
            startIcon={<SearchIcon />}
            fullWidth
            padding={"12px 10px"}
            placeholderFontSize="14px"
            value={jobData.search}
            disabled={jobData.loading || chatBotData.loader}
            onChange={handleSearchInput}
          />

          <CommonGrid2
            marginTop={"1.5rem"}
            display={"flex"}
            gap={"0rem"}
            flexDirection={"column"}
          >
            <Typography variant="body4" fontWeight={600}>
              Recent Candidates
            </Typography>

            <CommonGrid2
              marginTop={"1rem"}
              display={"flex"}
              flexDirection="column"
              scrollStyle
              overflow={"auto"}
              width={jobData.loading ? "100%" : "calc(100% + 20px)"}
              height="calc(100vh - 9rem)"
              left={jobData.loading ? "0px" : "-10px"}
              paddingRight={jobData.loading ? "0px" : "10px"}
              position={"relative"}
              scrollBar="5px"
            >
              <div ref={listRef} style={{ height: "100%", overflowY: "auto" }}>
                {jobData.loading ? (
                  Array.from({ length: 10 }).map((_, index) => (
                    <HandleSkeletion
                      key={index}
                      height={50}
                      transform="scale(1)"
                      marginBottom="1rem"
                    />
                  ))
                ) : jobData.data?.length !== 0 ? (
                  jobData.data.map((item) => (
                    <CommonTippy
                      key={item.resume_id}
                      content={`${item.id} - ${item.name}`}
                      placement="top"
                      color={"#7F56D9"}
                      fontSize="12px"
                      bottom={"5px"}
                      disabled={chatBotData.loader}
                    >
                      <CustomDiv width="100%">
                        <CommonButton
                          width={"100%"}
                          value={`${item.id} - ${item.name}`}
                          padding={"10px 12px"}
                          onClick={() => handleButtonClick(item)}
                          background={
                            item.resume_id == jobData.value?.resume_id
                              ? "#EBE1F9"
                              : "transparent"
                          }
                          color={
                            item.resume_id == jobData.value?.resume_id
                              ? "#6947B0"
                              : "#344054"
                          }
                          fontWeight={
                            item.resume_id == jobData.value?.resume_id
                              ? "700"
                              : "500"
                          }
                          customStyle={{
                            justifyContent: "start",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            minHeight: "45px",
                            display: "inline-block",
                            alignItems: "center",
                            textAlign: "left",
                            "&:hover": { boxShadow: "none" },
                          }}
                          disabled={chatBotData.loader}
                          boxShadow={"none"}
                        />
                      </CustomDiv>
                    </CommonTippy>
                  ))
                ) : (
                  <DataFound padding="10px" margin="auto">
                    <CustomDiv fontSize="20px">👋</CustomDiv>
                    {"No results found"}
                  </DataFound>
                )}
                {jobData.loadMoreLoading && (
                
                  <HandleSkeletion height={50} marginTop="1rem" />
                )}
              </div>
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>
      </CommonGrid2>
    );
  }, [jobData]);

  return (
    <CustomDiv
      overflowY="auto"
      height="100%"
      display="flex"
      width="100%"
      gap="0.8rem"
    >
      <CommonGrid2
        width={"calc(100% - 300px)"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        borderRadius={"10px"}
        position={"relative"}
        background="#F6F8FB"
        height="calc(100% - 3rem)"
        margin="1.5rem 0rem 1.5rem 1.5rem"
      >
        <CommonGrid2
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
          overflow={"auto"}
          padding={"1rem"}
          scrollBar="6px"
          scrollStyle
          customStyle={{ overflowX: "hidden" }}
          height="calc(100vh - 3.5rem)"
        >
          <CustomDiv margin="0px 0px 1rem">
            <Typography
              variant="body5"
              color="#8396A8"
              fontWeight={700}
              sx={{
                background:
                  "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Here is the status of the candidate
              <CustomizeSpan margin="0px 0px 0px 8px">
                <StarShrinkIco />
              </CustomizeSpan>
            </Typography>
            {jobData.loading ? (
              <HandleSkeletion height={50} marginTop="1rem" />
            ) : (
              <CommonGrid2
                display={"flex"}
                flexWrap={"wrap"}
                gap={"1rem"}
                margin={"1rem 0px 0px"}
              >
                <Typography variant="h5">{jobData.value?.job_title}</Typography>
                <StatusChange>
                  <DotColor color={getColor(90)} />
                  {jobData.value?.status}
                </StatusChange>
              </CommonGrid2>
            )}
          </CustomDiv>
          <FullSizeChatBot
            disabled={jobData.data?.length === 0}
            chatBotData={chatBotData}
            handleChatBotChange={handleChatBotChange}
            setIsBottomVisible={setIsBottomVisible}
            isBottomVisible={isBottomVisible}
            handleSendMessage={handleSendMessage}
            customStyle={{
              width: "calc(100% + 16px)",
              padding: "0px 10px 0px 5px",
              "&::-webkit-scrollbar": {
                width: "6px",
              },
            }}
          />
        </CommonGrid2>
      </CommonGrid2>
      {memoizedSidebar}
    </CustomDiv>
  );
}
